import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import {Card, CardActions, CardContent, CardHeader, LinearProgress, Tooltip, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Button from "@mui/material/Button";
import {FormProvider, useForm} from "react-hook-form";
import {CSV_INITIAL_STATE, CsvReducer, initCsvState} from "../../../../reducers/CsvReducer";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AppContext} from "../../../../App";
import FileInput from "../utils/FileInput";
import {addGuariti, checkStatusUpload} from "../../../../services/CsvServices";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

function LinearProgressWithLabel(props) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

LinearProgressWithLabel.propTypes = {
	/**
	 * The value of the progress indicator for the determinate and buffer variants.
	 * Value between 0 and 100.
	 */
	value: PropTypes.number.isRequired,
};

const GuaritiCard = () => {
	const classes = BaseStyle();
	const methods = useForm({mode: "onChange",});
	const [state, dispatch] = useReducer(CsvReducer, CSV_INITIAL_STATE, initCsvState);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	const [startCheck, setStartCheck] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true)
		addGuariti(data, dispatch);
	}, [dispatch])
	
	useEffect(() => {
		if (submit && !state.loadingAddTamponi && state.errorAddTamponi === "") {
			setOpenSnackbar("success", "Caricamento in corso", appContext.dispatch);
			setSubmit(false);
			setStartCheck(true);
			checkStatusUpload(state.idUpload, dispatch);
		}
	}, [state.loadingAddTamponi, state.errorAddTamponi, appContext.dispatch, submit, state.idUpload]);
	
	useEffect(() => {
		if (startCheck && !state.loadingCheckStatus && state.errorCheckStatus === "") {
			if (state.status?.percentage < 100) {
				setTimeout(() => {
					checkStatusUpload(state.idUpload, dispatch);
				}, 2000)
			} else {
				setStartCheck(false);
			}
		} else if (startCheck && !state.loadingCheckStatus && state.errorCheckStatus !== "") {
			setStartCheck(false);
			alert(state.errorCheckStatus);
		}
	}, [startCheck, state.loadingCheckStatus, state.errorCheckStatus, state.status, state.idUpload])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder, classes.transparent)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<FormProvider {...methods} >
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<CardHeader
							title={<Typography variant={"h6"}><b>Caricamento dei guariti</b></Typography>}
							subheader={"Segui le indicazioni per caricare correttamente i guariti da Gestione Pazienti. In caso di errori durante il " +
								"caricamento ti invito a contattare tempestivamente gli sviluppatori dlell'ICT"}
						/>
						<CardContent style={{flexGrow: 1}}>
							
							<FileInput
								accept='.csv'
								multiple
								name='csv'
							/>
							
							<LinearProgressWithLabel value={state.status.percentage ? state.status.percentage : 0}/>
						
						</CardContent>
						<CardActions className={classes.flexRight}>
							<Tooltip
								title={"Dopo aver controllato minuziosamente di aver caricato il file in modo corretto e nel giusto formato, " +
									"clicca su conferma per inviarlo al server che farà le magie."}>
								<Button variant={"contained"} disableElevation size="small" color="primary"
								        style={{borderRadius: 24}}
								        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
									<b>Conferma e carica</b>
								</Button>
							</Tooltip>
						</CardActions>
					</form>
				</FormProvider>
			</Card>
		</React.Fragment>
	);
}

export default React.memo(GuaritiCard)
